<div class="agpr-view-in-browser" *ngIf="show">
    {{text}}
</div>

